import { render } from "./illuminationControllerDaliDim.vue?vue&type=template&id=be8bf1e2&scoped=true"
import script from "./illuminationControllerDaliDim.vue?vue&type=script&lang=js"
export * from "./illuminationControllerDaliDim.vue?vue&type=script&lang=js"

import "./illuminationControllerDaliDim.vue?vue&type=style&index=0&id=be8bf1e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8bf1e2"]])

export default __exports__